import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class GdnService {
static gdnCreate = async (bodyFormData) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/dispatch/create",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static gdnDetailsSearch = async (productId, searchTerm, rowsPerPage, page) => {
    try {
      let filter = [];

      if(searchTerm){
        filter.push({'keyword': searchTerm})
      }

      if(productId){
        filter.push({'productId': productId})
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/dispatch/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let gdnDetail = response.data.data;
      return gdnDetail;
    } catch (err) {
      throw err;
    }
  };

  static gdnDetailsID = async (gdnID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/dispatch/" + gdnID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let gdnDetailID = response.data.data;

      return gdnDetailID;
    } catch (err) {
      throw err;
    }
  };

  static gdnAllDetails = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/dispatch/get/all",
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let gdnDetail = response.data.data;

      return gdnDetail;
    } catch (err) {
      throw err;
    }
  };

  static gdnDelete = async (gdnID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/dispatch/delete/" + gdnID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static gdnUpdate = async (gdnID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/dispatch/update/" + gdnID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static gdnItemDelete = async (gdnItemID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/dispatch/delete/gdn-item/" + gdnItemID,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

}
